import { render, staticRenderFns } from "./BankTransferFilesView.vue?vue&type=template&id=2d6f8eaf&scoped=true&"
import script from "./BankTransferFilesView.vue?vue&type=script&lang=js&"
export * from "./BankTransferFilesView.vue?vue&type=script&lang=js&"
import style0 from "./BankTransferFilesView.vue?vue&type=style&index=0&id=2d6f8eaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6f8eaf",
  null
  
)

export default component.exports